import React from 'react';
import classNames from 'classnames/bind';
import { Text } from '@carnica/ui-kit';
import { useIsMobileDimension } from '@carnica/utils/hooks';
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var HomeServices = function HomeServices(_ref) {
  var items = _ref.items;
  var isMobile = useIsMobileDimension();
  return /*#__PURE__*/React.createElement("div", {
    className: cn('container'),
    "data-t-id": "components-HomeServices"
  }, items.map(function (item) {
    return /*#__PURE__*/React.createElement("div", {
      className: cn('item'),
      key: item.value
    }, /*#__PURE__*/React.createElement("img", {
      alt: "icon",
      className: cn('icon'),
      src: item.iconSrc
    }), /*#__PURE__*/React.createElement("div", {
      className: cn('description')
    }, /*#__PURE__*/React.createElement(Text, {
      variant: isMobile ? 'caption-medium' : 'body-paragraph-small'
    }, item.value), /*#__PURE__*/React.createElement(Text, {
      variant: isMobile ? 'caption-medium' : 'body-paragraph-small'
    }, item.unit)));
  }));
};